import { c as _c } from "react/compiler-runtime";
import { cn } from '@/utilities/ui';
import React from 'react';
import RichText from '@/components/RichText';
import { Media } from '../../components/Media';
export const MediaBlock = props => {
  const $ = _c(23);
  const {
    captionClassName,
    className,
    enableGutter: t0,
    imgClassName,
    media,
    position: t1,
    staticImage,
    disableInnerContainer
  } = props;
  const enableGutter = t0 === undefined ? true : t0;
  const position = t1 === undefined ? "default" : t1;
  let caption;
  if (media && typeof media === "object") {
    caption = media.caption;
  }
  const t2 = position === "default" && enableGutter;
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("", {
      container: t2
    }, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== imgClassName || $[4] !== media || $[5] !== position || $[6] !== staticImage) {
    t4 = position === "fullscreen" && <div className="relative"><Media resource={media} src={staticImage} videoClassName={cn("!w-screen", imgClassName)} imgClassName={cn("!w-screen", imgClassName)} /></div>;
    $[3] = imgClassName;
    $[4] = media;
    $[5] = position;
    $[6] = staticImage;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== imgClassName || $[9] !== media || $[10] !== position || $[11] !== staticImage) {
    t5 = position === "default" && <Media imgClassName={cn("rounded", imgClassName)} resource={media} src={staticImage} />;
    $[8] = imgClassName;
    $[9] = media;
    $[10] = position;
    $[11] = staticImage;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== caption || $[14] !== captionClassName || $[15] !== disableInnerContainer || $[16] !== position) {
    t6 = caption && <div className={cn("mt-6", {
      container: position === "fullscreen" && !disableInnerContainer
    }, captionClassName)}><RichText data={caption} enableGutter={false} /></div>;
    $[13] = caption;
    $[14] = captionClassName;
    $[15] = disableInnerContainer;
    $[16] = position;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t7 = <div className={t3}>{t4}{t5}{t6}</div>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};